import { ConfigProvider } from 'antd-mobile'
import logo from './logo.svg';
import Router from './pages/Router';
import enUS from 'antd-mobile/es/locales/en-US'
function App() {
  
  return (
    <ConfigProvider locale={enUS}>
        <Router />
      </ConfigProvider>
  );



}

export default App;
